import api from "@/assets/js/api"; // 引用 API 模組
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於彈出提示

export default {
  name: "MemberManagement",
  data() {
    return {
      members: [], // 會員資料
      searchQuery: "", // 搜尋關鍵字
      filteredMembers: [], // 搜尋後的資料
      currentPage: 1, // 當前頁數
      itemsPerPage: 10, // 每頁顯示數量
      idSortOrder: "asc", // ID 排序方式
      dateSortOrder: "asc", // 註冊日期排序方式 排序方式：'asc' 為升序, 'desc' 為降序
      showModal: false, // 控制模態框顯示
      selectedMember: {}, // 當前選中的會員資料
      // 1/11 加入
      currentOrderPage: 1, // 當前頁數
      itemsPerOrderPage: 5, // 每頁顯示的訂單數量
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredMembers.length / this.itemsPerPage);
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    paginatedMembers() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;

      // 直接返回切片後的資料，不再生成新的 displayId
      return this.filteredMembers.slice(startIndex, endIndex);
    },

    // 1/11 加入
    //歷史訂單
    // 總頁數
    totalOrderPages() {
      return Math.ceil(
        this.selectedMember.orders.length / this.itemsPerOrderPage
      );
    },
    // 是否有上一頁
    hasPreviousOrderPage() {
      return this.currentOrderPage > 1;
    },
    // 是否有下一頁
    hasNextOrderPage() {
      return this.currentOrderPage < this.totalOrderPages;
    },
    // 當前頁面的訂單
    paginatedSelectedOrders() {
      if (
        !this.selectedMember.orders ||
        this.selectedMember.orders.length === 0
      )
        return []; // 確保 orders 存在並且為非空
      const startIndex = (this.currentOrderPage - 1) * this.itemsPerOrderPage;
      const endIndex = startIndex + this.itemsPerOrderPage;
      return this.selectedMember.orders.slice(startIndex, endIndex);
    },
  },
  methods: {
    // 日期格式化函數
    formatDate(date) {
      if (!date) return ""; // 如果日期為空，返回空字串
      const formattedDate = new Date(date).toISOString().split("T")[0]; // 僅返回日期部分
      return formattedDate;
    },
    formatDateWithoutTimezone(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 從後端獲取會員資料
    async fetchMembers() {
      try {
        const response = await api.get("/Member/role0");
        this.members = response.data.map((member) => ({
          ...member,
          birth: member.birth
            ? this.formatDateWithoutTimezone(member.birth)
            : "",
          createdAt: member.createdAt
            ? this.formatDateWithoutTimezone(member.createdAt)
            : "",
        }));
        this.filteredMembers = [...this.members];
        this.sortById(); // 預設按 ID 排序
      } catch (error) {
        console.error("獲取會員資料失敗:", error);
        Swal.fire({
          icon: "error",
          title: "取得失敗",
          text: "無法獲取會員資料，請稍後再試！",
          confirmButtonText: "確定",
        });
      }
    },

    // 1/11 加入
    // 獲取會員歷史訂單數據
    // 獲取會員歷史訂單數據
    async fetchMemberOrderHistory(memberId) {
      try {
        const response = await api.get(`/Member/${memberId}/order-history`);
        this.selectedMember.orders = (response.data || []).map((order) => ({
          OrderId: order.OrderId || "N/A", // 訂單編號
          MemberId: order.MemberId || "N/A", // 會員ID
          MemberName: order.MemberName || "未知會員", // 會員名稱
          OrderDate: order.OrderDate || "未知日期", // 訂單日期
          TotalAmount: order.TotalAmount || 0, // 訂單總金額
          OrderStatus: order.OrderStatus || "未知狀態", // 訂單狀態
          RoomTypeName: order.RoomTypeName || "N/A", // 房型名稱
        }));
        console.log("歷史訂單獲取成功:", this.selectedMember.orders);
      } catch (error) {
        console.error("獲取歷史訂單失敗:", error);
        console.log("無法獲取歷史訂單，請稍後再試！");
        this.selectedMember.orders = []; // 確保為空陣列
      }
    },

    // 切換排序方式
    toggleSortOrder(field) {
      if (field === "id") {
        this.idSortOrder = this.idSortOrder === "asc" ? "desc" : "asc";
        this.sortById();
      } else if (field === "createdAt") {
        this.dateSortOrder = this.dateSortOrder === "asc" ? "desc" : "asc";
        this.sortByDate();
      }
    },

    //按id
    sortById() {
      this.filteredMembers.sort((a, b) => {
        return this.idSortOrder === "asc" ? a.id - b.id : b.id - a.id;
      });
    },

    //按註冊日期
    sortByDate() {
      this.filteredMembers.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return this.dateSortOrder === "asc" ? dateA - dateB : dateB - dateA;
      });
    },

    // 搜尋會員
    filterMembers(query) {
      const keyword = query.trim().toLowerCase();
      this.filteredMembers = this.members.filter((member) =>
        member.email.toLowerCase().includes(keyword)
      );
      this.currentPage = 1; // 搜尋後重置為第一頁
    },

    // 過濾黑名單會員
    filterBlacklist() {
      this.filteredMembers = this.members.filter(
        (member) => member.locked === true
      );
      this.currentPage = 1; // 重置到第一頁
    },

    // 新增會員
    addMember() {
      Swal.fire({
        icon: "info",
        title: "尚未開放",
        text: "新增會員功能尚未實作",
        confirmButtonText: "了解",
      });
    },
    // 編輯會員
    editMember(member) {
      Swal.fire({
        icon: "info",
        title: "編輯會員",
        text: `編輯會員: ${member.name}`,
        confirmButtonText: "確定",
      });
    },
    // 刪除會員
    async deleteMember(id) {
      if (!confirm("確定要刪除這位會員嗎？")) return;

      try {
        const response = await api.delete(`/Member/${id}`);
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "刪除成功",
            text: "會員刪除成功",
            confirmButtonText: "確定",
          }).then(() => {
            this.fetchMembers(); // 刪除後重新加載會員資料
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "刪除失敗",
            text: "請稍後再試！",
            confirmButtonText: "確定",
          });
        }
      } catch (error) {
        console.error("刪除會員失敗:", error);
        Swal.fire({
          icon: "error",
          title: "刪除失敗",
          text: "無法刪除會員！",
          confirmButtonText: "確定",
        });
      }
    },
    // 回到會員清單頁
    goToMemberList() {
      if (this.$route.path === "/admin/users") {
        // 當前已在目標頁面，僅更新資料
        this.fetchMembers(); // 重新加載會員資料
      } else {
        // 切換到會員清單頁
        this.$router.push("/admin/users");
      }
    },
    // 顯示會員詳細資訊
    async showMemberDetails(member) {
      this.selectedMember = { ...member, orders: [] }; // 初始化 orders 為空陣列
      this.showModal = true; // 顯示模態框
      await this.fetchMemberOrderHistory(member.id); // 請求歷史訂單
    },
    // 關閉模態框
    closeModal() {
      this.showModal = false;
      this.selectedMember = {}; // 清空選中會員資料
    },
    // 保存會員資料
    async saveMemberDetails() {
      try {
        // 驗證必填欄位
        if (!this.selectedMember.fullName || !this.selectedMember.email) {
          Swal.fire({
            icon: "warning",
            title: "欄位未填",
            text: "會員名稱與 Email 為必填！",
            confirmButtonText: "確定",
          });

          return;
        }

        // 驗證電話格式
        const phoneRegex = /^\d{10}$/;
        if (!phoneRegex.test(this.selectedMember.phone)) {
          Swal.fire({
            icon: "warning",
            title: "格式錯誤",
            text: "電話必須是 10 碼！",
            confirmButtonText: "確定",
          });

          return;
        }

        // 驗證 Email 格式
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.selectedMember.email)) {
          Swal.fire({
            icon: "warning",
            title: "格式錯誤",
            text: "請輸入合法的 Email！",
            confirmButtonText: "確定",
          });

          return;
        }

        // 傳遞給後端的資料，僅保留必要的欄位
        const payload = {
          id: this.selectedMember.id,
          fullName: this.selectedMember.fullName,
          email: this.selectedMember.email,
          phone: this.selectedMember.phone || "N/A",
          countries: this.selectedMember.countries || "N/A",
          birth: this.selectedMember.birth,
          locked: this.selectedMember.locked,
          createdAt: this.selectedMember.createdAt,
        };

        console.log("[DEBUG] 發送給後端的資料:", payload);

        // 發送請求
        const response = await api.put(
          `/Member/${this.selectedMember.id}`,
          payload
        );

        if (response.status === 200) {
          Swal.fire({
            icon: "success", // ✅ 成功圖示
            title: "更新成功", // 標題
            text: "會員資料更新成功！", // 提示內容
            confirmButtonText: "確定", // 按鈕文字
          });

          this.closeModal(); // 關閉模態框
          this.fetchMembers(); // 重新加載會員列表
        } else {
          Swal.fire({
            icon: "error",
            title: "更新失敗",
            text: "更新會員資料失敗，請稍後再試！",
            confirmButtonText: "確定",
          });
        }
      } catch (error) {
        // 捕獲錯誤並顯示詳細訊息
        console.error(
          "[ERROR] 更新會員資料失敗:",
          error.response || error.message
        );

        // 提取後端返回的錯誤訊息
        const backendError =
          error.response?.data?.errors || error.response?.data || {};
        console.error("[ERROR DETAILS] 後端錯誤詳細訊息:", backendError);

        // 提示具體錯誤訊息
        Swal.fire({
          icon: "error", // 錯誤圖示
          title: "更新會員資料失敗！", // 標題
          html: `
    <p><strong>錯誤訊息：</strong><br>${
      backendError.message || "未知錯誤，請稍後再試。"
    }</p>
    <p><strong>詳細資訊：</strong><br><pre style="text-align:left; background:#f5f5f5; padding:8px; border-radius:4px;">${JSON.stringify(
      backendError,
      null,
      2
    )}</pre></p>
  `, // 使用 html 支援換行與 JSON 格式化
          confirmButtonText: "確定",
        });
      }
    },

    // 分頁操作
    prevPage() {
      if (this.hasPreviousPage) this.currentPage--;
    },
    nextPage() {
      if (this.hasNextPage) this.currentPage++;
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    // 1/11 加入
    // 切換到上一頁
    prevOrderPage() {
      if (this.hasPreviousOrderPage) this.currentOrderPage--;
    },
    // 切換到下一頁
    nextOrderPage() {
      if (this.hasNextOrderPage) this.currentOrderPage++;
    },
    // 切換到指定頁數
    goToOrderPage(page) {
      if (page >= 1 && page <= this.totalOrderPages) {
        this.currentOrderPage = page;
      }
    },
  },
  created() {
    this.fetchMembers();
    this.fetchMemberOrderHistory();
  },
  watch: {
    searchQuery: {
      immediate: true,
      handler(query) {
        this.filterMembers(query);
      },
    },
  },
};
